module.exports = __webpack_public_path__ + "static/img/ID_card_front.f6686c62.png";